import React from 'react';
import { Helmet } from 'react-helmet';

import { spanish } from '../../../config/config';
import BillingRequest from '../../../components/Billing/Request';

const BillingRequestPage = () => (
  <>
    <Helmet title={spanish ? 'Facturación' : 'Billing'} />
    <BillingRequest />
  </>
);

export default BillingRequestPage;
